import DateHelper from '@/lib/DateHelper'
const ClubsLayout = () => import('@/components/Dashboard/Views/Clubs/Layout/ClubsLayout.vue')
const Clubs = () => import('@/components/Dashboard/Views/Clubs/Clubs')
const Sports = () => import('@/components/Dashboard/Views/Clubs/Sports')
const DashboardLayout = () => import('@/components/Dashboard/Layout/DashboardLayout.vue')

function week() {
  return `${DateHelper.getWeekNumber()}`
}
function year() {
  return `${DateHelper.getYearNumber()}`
}

export default {
  path: 'clubs',
  component: DashboardLayout,
  props: true,
  children: [
    {
      path: '',
      component: ClubsLayout,
      props: true,
      redirect: {
        name: 'Sports',
      },
      children: [
        /*
        {
          path: '',
          name: 'Clubs',
          component: Clubs,
          props: true,
        },
        */
        {
          path: 'sports',
          name: 'Sports',
          component: Sports,
          props: true,
        },
        {
          name: 'SportClubs',
          path: ':sport',
          redirect: `/clubs/:sport/${year()}/${week()}`,
        },
        {
          path: ':sport/:yearId',
          redirect: `/clubs/:sport/:yearId/${week()}`,
        },
        {
          path: ':sport/:yearId/:weekId',
          name: 'Clubs',
          component: Clubs,
          props: true,
        },
      ],
    },
  ],
}
